<template>
	<section class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="日统计" name="date"></el-tab-pane>
			<el-tab-pane label="月统计" name="month"></el-tab-pane>
		</el-tabs>
		<div class="content-box">
			<div class="operator">
				<div class="operator-col">
					<hispickup v-model="filterHisDate" :params="hisParam"></hispickup>
				</div>
				<div class="operator-col">
					<warehouse-input v-model="filterWarehouse"></warehouse-input>
				</div>
			</div>
		</div>
		<div class="mt-3 content-box">
			<ve-line :data="chartData" :settings="chartSettings" :colors="colors" :extend="chartExtend"></ve-line>
			<curd-table
				ref="listTable"
				data-model="Report"
				:fields="tableFields"
				@doedit="handleEdit($event)"
				@change="handleDataChanged"
				:date-filter="filterHisDate"
				:search-filter="filterTableSearch"
				:has-delete="false"
				:list-ops="[]"
				:kv-filter="kvFilter"
				:list-url="'analyse/sum_date/'+activeName"
			></curd-table>
		</div>
	</section>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";

import VeLine from "v-charts/lib/line.common";

export default {
	components: { VeLine },
	mixins: [CurdPage, Filters],
	data() {
		return {
			datas: [],
			activeName: "date",
			chartData: {
				columns: [
					"date",
					"sum_amount",
					"sum_total_price",
					"sum_total_cost",
					"sum_gross_profit",
					"profit_rate"
				],
				rows: []
			},
			chartSettings: {
				dimension: ["date"],
				scale: [true, true],
				axisSite: { right: ["profit_rate"] },
				yAxisType: ["normal", "percent"],
				yAxisName: ["数值", "毛利率"],
				labelMap: {
					date: "日期",
					sum_amount: "件数",
					sum_total_price: "总价",
					sum_total_cost: "总成本",
					sum_gross_profit: "总利润",
					profit_rate: "毛利率"
				}
			},
			chartExtend: {
				xAxis: {
					axisLabel: {
						showMinLabel: true,
						showMaxLabel: true
					}
				}
			},
			colors: [
				"#7cb5ec",
				"#FFD700",
				"#fa6464",
				"#61a0a8",
				"#d48265",
				"#91c7ae",
				"#749f83",
				"#bda29a",
				"#6e7074",
				"#546570",
				"#c4ccd3"
			],
			tableFields: [
				{
					name: "date"
				},
				{
					name: "sum_amount",
					title: "件数",
					sortable: "custom",
					params: {
						isRight: true,
						toFixed: true,
						toFixedLength: 0
					}
				},
				{
					name: "sum_total_price",
					title: "总价",
					sortable: "custom",
					params: {
						isRight: true,
						toFixed: true,
						toFixedLength: 0
					}
				},
				{
					name: "sum_total_cost",
					title: "总成本 ",
					sortable: "custom",
					params: {
						isRight: true,
						toFixed: true,
						toFixedLength: 0
					}
				},
				{
					name: "sum_gross_profit",
					title: "总利润",
					sortable: "custom",
					params: {
						isRight: true,
						toFixed: true,
						toFixedLength: 0
					}
				},
				{
					name: "profit_rate",
					title: "毛利率",
					params: {
						isRight: true,
						postfix: "%",
						toFixed: true,
						toFixedLength: 2
					}
				}
			]
		};
	},
	computed: {
		hisParam() {
			let param = {
				range: 0,
				rangeMsg: ""
			};
			if (this.activeName == "date") {
				param.range = 86400 * 90 * 1000;
				param.rangeMsg = "按日分析上限90天";
			} else if (this.activeName == "month") {
				param.range = 86400 * 31 * 36 * 1000;
				param.rangeMsg = "按月分析上限36个月";
			}
			return param;
		}
	},
	created() {},
	mounted() {},
	methods: {
		handleDataChanged(datas) {
			this.chartData.rows = JSON.parse(JSON.stringify(datas))
				.sort((a, b) => {
					return a.date - b.date;
				})
				.map(val => {
					// if (this.activeName=='date') {

					// }
					val.date = val.date.toString();
					val.profit_rate = val.profit_rate / 100;
					return val;
				});
		}
	},
	watch: {
		activeName() {
			this.$nextTick(() => {
				this.$refs["listTable"].refreshData();
			});
		}
	}
};
</script>
<style lang="scss" scoped>
.echarts {
	width: 100%;
	height: 100%;
}
</style>
